<template>
    <div>
        <base-spinner v-if="isLoading"/>
        <base-page v-else>
            <h3 class="text-primary my-3">
                <hemocir-button
                    :title="$t('utils.back')"
                    :to="{name: 'patient-detail-surgeries', params: {patientId: this.surgery.patient}}"
                    font-awesome-icon="fa-caret-left"
                    variant="outline-primary"
                />
                {{ $t('patient.patient') }} <b>{{ patient.code }}</b> / {{ patient.center.name }}
            </h3>

            <final-evaluation-display style="margin-left: -15px; margin-right: -15px;" @edit="editFinalEvaluation"/>
            <detail-surgery @save="reloadSurgery"/>
        </base-page>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import DetailSurgery from "@/components/surgery/detail/DetailSurgery";
    import FinalEvaluationDisplay from "@/components/finalevaluation/FinalEvaluationDisplay";
    import BasePageMixin from "@/components/BasePageMixin";
    import BasePage from "@/components/BasePage";
    import BaseSpinner from "@/components/BaseSpinner";

    export default {
        name: "SurgeryDetailPage",
        components: {
            BaseSpinner,
            BasePage,
            FinalEvaluationDisplay,
            DetailSurgery,
        },
        mixins: [BasePageMixin],
        props: {
            surgeryId: {
                type: Number,
                required: true,
            },
        },
        computed: {
            ...mapState([
                'patient',
                'surgery',
                'surgeryFields',
                'finalEvaluationFields',
                'bloodTestFields',
                'transfusionFields',
                'novoeightTreatmentFields',
                'outpatientTreatmentFields',
            ]),
        },
        async created() {
            this.setSurgery(null);
            await this.getSurgery(this.surgeryId);
            await this.getSurgeryOptions();
            await this.getTransfusionOptions();
            await this.getNovoeightTreatmentOptions();
            await this.getBloodTestOptions();
            await this.getFinalEvaluationOptions();
            await this.getAdjuvantTreatmentOptions();
            await this.getPatient(this.surgery.patient);
            this.isLoading = false;
        },
        methods: {
            ...mapActions([
                'getPatient',
                'setSurgery',
                'getSurgery',
                'getSurgeryOptions',
                'getTransfusionOptions',
                'getNovoeightTreatmentOptions',
                'getBloodTestOptions',
                'getFinalEvaluationOptions',
                'getAdjuvantTreatmentOptions',
            ]),
            async reloadSurgery() {
                await this.getSurgery(this.surgeryId);
            },
            editFinalEvaluation() {
                this.$router.push({name: 'surgery-final-evaluation', params: {surgeryId: this.surgeryId}});
            }
        }
    };
</script>

